module.exports = __webpack_public_path__ + "img/zhaoshang_shenhe@2x.e1284bb4.png";